<template>
    <div>
        <!-- 정보입력 -->
        <div class="join-row-wrap">
            <!-- 정보입련: 일반 -->
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">회원정보 필수입력</h3>
                </div>
                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <form-row title="아이디" v-model="user.username" @input="input" :inputProps="{ name: 'username' }" />
                        <form-row title="비밀번호" v-model="user.password" @input="input" :inputProps="{ name: 'password', type: 'password' }">
                            <small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
                        </form-row>
                        <form-row title="비밀번호 확인" v-model="user.passwordConfirm" @input="input" :inputProps="{ name: 'password2', type: 'password' }" />
                        <form-row title="기업명" v-model="user.companyName" @input="input" :inputProps="{ name: 'companyName' }" />
                        <form-row title="대표자명" v-model="user.ceoName" @input="input" :inputProps="{ name: 'ceoName' }" />
                        <form-row title="기업설립일">
                            <v-text-field v-model="user.establishedAt" @input="input" type="date" name="establishedAt" hide-details dense class="rounded-0" />
                        </form-row>
                        <form-row title="사업자등록번호" v-model="user.businessNumber" @input="input" :inputProps="{ name: 'businessNumber', maxlength: '10' }" />
                        <form-row title="연락처">
                            <div class="form-tel">
                                <input class="input" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                            </div>
                        </form-row>
                        <form-row title="이메일">
                            <div class="form-email">
                                <input class="input" type="text" name="email1" v-model="user.email1" />
                                <span class="text">@</span>
                                <input class="input" type="text" name="email2" v-model="user.email2" />
                                <select v-model="user.email3" class="select" @change="user.email2 = user.email3">
                                    <option :value="null">직접입력</option>
                                    <option :value="`naver.com`">naver.com</option>
                                    <option :value="`daum.net`">daum.net</option>
                                    <option :value="`google.com`">google.com</option>
                                </select>
                            </div>
                        </form-row>
                        <form-row title="주소">
                            <div class="form-address">
                                <div class="form-address__postcode">
                                    <input class="input" type="text" v-model="user.postcode" placeholder="우편번호" readonly @click="onSearchPostcode" />
                                    <button class="button button--primary" @click="onSearchPostcode">검색</button>
                                </div>
                                <input class="input" type="text" v-model="user.address1" placeholder="기본주소" readonly @click="onSearchPostcode" />
                                <input class="input" type="text" v-model="user.address2" placeholder="상세주소" />
                            </div>
                        </form-row>
                        <form-row title="관심분야">
                            <v-col v-for="parent in areas" :key="parent._id" cols="6" lg="">
                                <v-row>
                                    <v-col>{{ parent.name }}</v-col>
                                </v-row>
                                <v-row v-for="child in parent.children" :key="child._id">
                                    <v-col>
                                        <v-checkbox :label="child.name" v-model="user._areas" :value="child._id" @input="input" hide-details dense class="my-0 py-0" />
                                    </v-col>
                                    <v-col cols="12" v-if="child.name == '기타(입력)' && user._areas.includes(child._id)" class="pt-0">
                                        <v-text-field v-model="user.areas_manual[parent._id]" hide-details dense class="my-0 py-0" outlined />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </form-row>
                    </div>
                </div>
            </div>
            <div class="join-row-wrap">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">회원정보 선택입력</h3>
                </div>
                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <form-row title="홈페이지 주소" v-model="user.website" @input="input" :inputProps="{ name: 'website' }" />
                        <form-row title="담당자정보">
                            <div class="row row--small">
                                <div class="col-12 col-md-6">
                                    <v-text-field v-model="user.workerName" @input="input" placeholder="이름" outlined hide-details dense class="rounded-0" />
                                </div>
                                <div class="col-12 col-md-6">
                                    <v-text-field v-model="user.workerTitle" @input="input" placeholder="직책" outlined hide-details dense class="rounded-0" />
                                </div>
                            </div>
                        </form-row>
                        <form-row title="주요생산제품" v-model="user.mainProduct" @input="input" />
                        <form-row title="기업개요">
                            <v-textarea v-model="user.summary" class="rounded-0" @input="input" />
                        </form-row>
                        <form-row title="기업로고">
                            <v-file-input v-model="user.avatar" @input="input" dense hide-details outlined class="rounded-0" accept="image/*" />
                        </form-row>
                        <form-files title="소개자료" v-model="user.brochures" @input="input" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 하단버튼 -->
        <div class="bottom-button">
            <button class="button button--border-primary" @click="cancel()">
                <span>취소하기</span>
            </button>
            <button class="button button--primary" @click="submit()">
                <span>회원가입</span>
            </button>
        </div>

        <daum-postcode
            ref="daum-postcode"
            @change="
                ({ postcode, address }) => {
                    user.postcode = postcode;
                    user.address1 = address;
                }
            "
        ></daum-postcode>
    </div>
</template>

<script>
import FormRow from "../form-row.vue";
import FormFiles from "../form-files.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";

import { INDIVIDUAL_KINDS } from "@/assets/data/CONSTANTS";

const initialUser = {
    companyName: null,
    ceoName: null,
    establishedAt: null,
    businessNumber: null,
    website: null,
    workerName: null,
    workerTitle: null,
    mainProduct: null,
    summary: null,
    avatar: null,
    brochures: [],
};
export default {
    components: {
        FormRow,
        FormFiles,
        DaumPostcode,
    },
    props: ["value", "areas"],
    data() {
        return {
            user: { ...initialUser, ...this.$props.value } || { ...initialUser },

            INDIVIDUAL_KINDS,
        };
    },
    methods: {
        input() {
            this.$emit("input", this.user);
        },
        onSearchPostcode() {
            this.$refs["daum-postcode"].open();
        },
        cancel() {
            this.$router.go(-1);
        },

        submit() {
            if (this.validate()) this.$emit("submit", this.user);
        },

        validate() {
            try {
                if (!this.user.username) throw new Error("아이디를 입력해주세요.");

                if (!this.user.password) throw new Error("비밀번호를 입력해주세요.");
                if (!this.checkPassword(this.user.password)) return false;
                if (!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
                if (this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");

                if (!this.user.companyName) throw new Error("기업명을 입력해주세요.");
                if (!this.user.ceoName) throw new Error("대표자명을 입력해주세요.");
                if (!this.user.establishedAt) throw new Error("기업설립일을 입력해주세요.");
                if (!this.user.businessNumber) throw new Error("사업자등록번호를 입력해주세요.");

                if (!this.user.phone) throw new Error("휴대전화를 입력해주세요.");
                if (!this.user.email) throw new Error("이메일을 입력해주세요.");
                if (!this.user.postcode || !this.user.address1 || !this.user.address2) throw new Error("주소를 입력해주세요.");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");

            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");

            return true;
        },
    },
    watch: {
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
    },
};
</script>
